import { render } from "./Iban.vue?vue&type=template&id=383d695f"
import script from "./Iban.vue?vue&type=script&lang=js"
export * from "./Iban.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__